import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/system';
import { Button, Chip, Divider, Typography } from '@mui/material';
import AccountBox from '@mui/icons-material/AccountBox';
import LogoutIcon from '@mui/icons-material/Logout';

import AALogo from '@assets/images/dashboard/dashboard-logo.svg';
import { logoutUser } from '../../../../store/auth';
import styles from './LoggedInPageHeader.module.css';

function LoggedInPageHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { username } = useSelector((state) => state.auth);

  const onLogOut = () => {
    dispatch(logoutUser());
  };

  const navigateToLanding = () => {
    navigate('/landing');
  };

  return (
    <Box className={styles.LoggedInPageHeader}>
      <Box className={styles.LogoImgWrapper}>
        <img // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions -- @TODO change to button
          className={styles.LogoImg}
          src={AALogo}
          alt="AirAsia Logo"
          onClick={navigateToLanding}
        />
      </Box>
      <Typography
        className={styles.LogoTitle}
        variant="body1"
        component="div"
        onClick={navigateToLanding}>
        Payment Dashboard
      </Typography>
      <Box
        sx={{
          flexGrow: 2,
          marginLeft: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}>
        {process.env.REACT_APP_ENV !== 'production' && (
          <Chip
            color="info"
            label={process.env.REACT_APP_ENV}
            size="small"
          />
        )}
        {process.env.REACT_APP_VERSION && (
          <Typography
            className={styles.AppVersion}
            variant="caption"
            component="span">
            v{process.env.REACT_APP_VERSION}
          </Typography>
        )}
      </Box>
      <AccountBox
        className={styles.UserProfileImgWrapper}
        sx={{ color: 'white' }}
      />
      <Typography
        style={{ marginRight: '20px' }}
        className={styles.UserName}
        variant="subtitle1"
        display="block">
        Hi, {username}!
      </Typography>
      <Divider
        orientation="vertical"
        sx={{ bgcolor: 'white' }}
      />
      <Button
        sx={{ margin: '0 20px', color: 'white' }}
        className={styles.LogoutButton}
        variant="text"
        aria-label="logout"
        onClick={onLogOut}
        startIcon={<LogoutIcon />}>
        Logout
      </Button>
    </Box>
  );
}

export default LoggedInPageHeader;
